import { render, staticRenderFns } from "./DepartmentPage.vue?vue&type=template&id=20b91a8f&scoped=true"
import script from "./DepartmentPage.vue?vue&type=script&lang=ts"
export * from "./DepartmentPage.vue?vue&type=script&lang=ts"
import style0 from "./DepartmentPage.vue?vue&type=style&index=0&id=20b91a8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b91a8f",
  null
  
)

export default component.exports